import { IconInformation } from '../../../../assets/DesignSystem/SVGComponents';
import { ICountryDetail } from '../../../../types/countries';
import { VAT_VALUE_BY_COUNTRY } from '../../../../utils/productDefinitions';
import BordOneToneIcon from '../../../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { nudosBlue } from '../../../../styles/styles.constants';
import './BordInvoiceInfo.scss';

interface IBordInvoiceInfo {
  beneficiary: string;
  countryName: string;
  countryEmissionFlag: string;
  isInvoicingWithIVA: boolean;
  billingProvider?: string;
  billingCountry?: ICountryDetail;
  withProviderInfo?: boolean;
}

export enum BILLING_PROVIDER_TYPE {
  MANUAL = 'manual',
  STRIPE = 'stripe',
  GIGSTACK = 'gigstack',
  BORD = 'bord',
  BRINTA = 'brinta'
}

export const BordInvoiceInfo = ({
  beneficiary,
  countryName,
  countryEmissionFlag,
  isInvoicingWithIVA,
  billingProvider,
  billingCountry,
  withProviderInfo = true
}: IBordInvoiceInfo) => {
  const getBillingProviderType = (provider?: string): BILLING_PROVIDER_TYPE => {
    if (!provider) return BILLING_PROVIDER_TYPE.MANUAL;
    if (provider.includes('stripe')) return BILLING_PROVIDER_TYPE.STRIPE;
    if (provider === BILLING_PROVIDER_TYPE.GIGSTACK) return BILLING_PROVIDER_TYPE.GIGSTACK;
    if (provider === BILLING_PROVIDER_TYPE.BORD) return BILLING_PROVIDER_TYPE.BORD;
    if (provider === BILLING_PROVIDER_TYPE.BRINTA) return BILLING_PROVIDER_TYPE.BRINTA;
    return BILLING_PROVIDER_TYPE.MANUAL;
  };

  const billingProviderLabels: Record<BILLING_PROVIDER_TYPE, string> = {
    [BILLING_PROVIDER_TYPE.MANUAL]: 'Manual',
    [BILLING_PROVIDER_TYPE.STRIPE]: 'Stripe',
    [BILLING_PROVIDER_TYPE.GIGSTACK]: 'Gigstack',
    [BILLING_PROVIDER_TYPE.BORD]: 'Bord',
    [BILLING_PROVIDER_TYPE.BRINTA]: 'Brinta'
  };

  const billingProviderType = getBillingProviderType(billingProvider);
  const billingProviderText = billingProviderLabels[billingProviderType] || '';
  const specificVatText = VAT_VALUE_BY_COUNTRY[billingCountry?.code || '']
    ? `del ${VAT_VALUE_BY_COUNTRY[billingCountry?.code || '']}%`
    : '';
  const invoiceWithoutIVA = !isInvoicingWithIVA && billingCountry?.code ? `Se resta el IVA ${specificVatText}` : '';

  return (
    <div className="bordInvoiceInfo">
      <span>
        <BordOneToneIcon variant="building3" customWidth="13px" stroke={nudosBlue} />
      </span>
      <article className="bordInvoiceInfoContent">
        <p>
          <span className="labelRazonSocial">Razón social:</span> {beneficiary}
        </p>
        <p className="billingCountry">
          <span className="labelCountryEmission">País de emisión:</span> {countryName || ''}
          <span>
            <img src={countryEmissionFlag} alt="Imágen del país de emisión" className="billingCountryFlag" />
          </span>
        </p>
        <div className="containerProviderInfo">
          {withProviderInfo && (
            <div className="containerProvider">
              <span className="labelProvider">Proveedor de factura:</span>
              <p className="valueProvider">{billingProviderText}</p>
            </div>
          )}
          <div className="containerIVA">
            {isInvoicingWithIVA ? (
              <>
                <span>
                  <BordOneToneIcon variant="checkCircle" stroke="#383838" className="checkCircleIcon" />
                </span>{' '}
                Con IVA
              </>
            ) : (
              <>
                <span>
                  <IconInformation color="#383838" fill="transparent" />
                </span>{' '}
                {invoiceWithoutIVA || 'Sin IVA'}
              </>
            )}
          </div>
        </div>
      </article>
    </div>
  );
};
